import React from 'react'
import styles from './styles.module.scss'
import PendingApproval from './PendingApproval'
import PendingSuggestions from './PendingSuggestions'
import PendingInvitations from './PendingInvitations'
import SectionTitle from '../common/SectionTitle'
import { useTranslation } from 'react-i18next'

function PendingActions({ type, data, objectId, pendingInvitations, showUserLightModal, autoApprovalToJoin }) {
  const { t } = useTranslation()
  const showPendingApprovalSection =
    type === 'group' && autoApprovalToJoin === 0 && data?.Pending_new_member?.length > 0
  const showPendingSuggestionSection = type === 'group' && data?.Pending_mixr_suggestion?.length > 0
  const showPendingInvitations = pendingInvitations?.Pending_invite?.length > 0

  return showPendingApprovalSection || showPendingSuggestionSection || showPendingInvitations ? (
    <React.Fragment>
      <SectionTitle title={type === 'group' ? t('dashboard.pendingActions') : t('dashboard.invitations.title')} />
      <div className={styles.pendingActions}>
        {showPendingApprovalSection || showPendingSuggestionSection ? (
          <div className={styles.row1}>
            <PendingApproval
              newMembers={data?.Pending_new_member}
              autoApprovalToJoin={autoApprovalToJoin}
              showUserLightModal={showUserLightModal}
              isFullWidth={showPendingApprovalSection && !showPendingSuggestionSection}
            />
            <PendingSuggestions
              mixrSuggestions={data?.Pending_mixr_suggestion}
              isFullWidth={!showPendingApprovalSection && showPendingSuggestionSection}
            />
          </div>
        ) : null}
        {showPendingInvitations && (
          <div className={styles.row2}>
            <PendingInvitations type={type} objectId={objectId} invitationData={pendingInvitations} />
          </div>
        )}
      </div>
    </React.Fragment>
  ) : null
}

export default PendingActions
